import widgetsMgr from 'widgets/widgetsMgr';
import OptimizelyWidget from './widgets/OptimizelyWidget';
import OptimizelyTracking from './widgets/OptimizelyTracking';

widgetsMgr.addWidgetsList('global.widgets.optimizely', () => [
    ['optimizelyWidget', OptimizelyWidget],
    ['optimizelyTracking', OptimizelyTracking]
]);
